import { combineReducersWithScope } from '@mews-commander/utils';
import { MODULE_NAME } from '../module';
import filters from './filters';
import form from './form';
import matrix from './matrix';
import sidebar from './sidebar';

export default combineReducersWithScope(
    {
        filters,
        form,
        matrix,
        sidebar,
    },
    MODULE_NAME
);
